import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollToTopService {
  public elementToScroll = new BehaviorSubject<HTMLElement | Window>(window);
}
